import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import Wrapper from "../common/Wrapper";
import Header from "../common/Header";
import NotificationBar from "../Parts/NotificationBar";
import ResetPasswordComponent from "./ResetPasswordComponent";
import ErrorPage from "../Error/ErrorPage";

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },

  content: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "scroll",
  },

  container: {
    width: "90%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    flex: 1,
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "50px 40px 30px 40px",
    boxSizing: "border-box",
    margin: "40px auto",
    position: "relative",
    maxWidth: "640px",
  },

  title: {
    fontSize: "24px",
    fontWeight: 800,
    marginBottom: "40px",
  },

  desc: {
    marginBottom: "20px",
    width: "100%",
    textAlign: "center",
  },

  explaination: {
    fontSize: "12px",
  },
});

class UpdateSecurityQuestion extends React.Component {
  state = {
    showNotification: false,
    message: "",
    messageType: "success",
  };

  componentDidMount() {
    this.props.getUserInfo();
  }

  componentDidUpdate(prevProps) {
    if (
      !!prevProps.isResetting &&
      !this.props.isResetting &&
      (this.props.error === null || Object.keys(this.props.error).length === 0)
    ) {
      // 保存後、キーマンデータベースに遷移します
      this.props.goTo("/executive-list");
    }

    if (
      prevProps.message === "" &&
      this.props.message &&
      this.props.message !== ""
    ) {
      this.displayNotification(this.props.message, "success");
    } else if (
      prevProps.errorMessage === "" &&
      this.props.errorMessage &&
      this.props.errorMessage !== ""
    ) {
      this.displayNotification(this.props.errorMessage, "error");
    } else if (
      prevProps.shortMessage === "" &&
      this.props.shortMessage &&
      this.props.shortMessage !== ""
    ) {
      this.displayNotification(this.props.shortMessage, "green");
    }
  }

  displayNotification = (message, type = "success") => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  renderNotification = () => {
    if (this.state.showNotification) {
      return (
        <div style={{ position: "fixed", zIndex: 1000, top: 10, width: "99%" }}>
          <NotificationBar
            message={this.state.message}
            type={this.state.messageType}
            open={this.state.showNotification}
            onHandleClose={this.toggleNotification}
            autoClose={true}
            style={{
              width:
                this.state.messageType === "green" ? "fit-content" : "100%",
            }}
          ></NotificationBar>
        </div>
      );
    }
  };

  render() {
    const { classes, user } = this.props;

    //セキュリティ質問がされた場合、このページをアクセスできないようにする
    if (!user || !user.security_question) {
      return (
        <Wrapper className={classes.root}>
          <Header
            title="セキュリティ質問を設定"
            type="dark"
            hasBackBtn={false}
          />
          <div className={classes.content}>
            <div className={classes.container}>
              <Typography variant="title" className={classes.title}>
                セキュリティの質問を設定してください
              </Typography>
              <div className={classes.desc}>
                <Typography variant="caption" className={classes.explaination}>
                  セキュリティ向上のため、パスワードに加えセキュリティの質問を設定します。
                </Typography>
              </div>

              <ResetPasswordComponent
                buttonText="保存"
                user={user}
                showPassword={false}
                showSecurityQuestion={true}
                error={this.props.error}
                addKeyDownListener={true}
                postUsersUpdatePassword={this.props.postUsersUpdatePassword}
              />
            </div>
          </div>

          {this.renderNotification()}
        </Wrapper>
      );
    } else {
      return <ErrorPage code={404} />;
    }
  }
}

UpdateSecurityQuestion.propTypes = {
  classes: PropTypes.object.isRequired,
  error: PropTypes.object,
  message: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  isResetting: PropTypes.bool,
  user: PropTypes.object,
  getUserInfo: PropTypes.func.isRequired,
  postUsersUpdatePassword: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
};

export default withStyles(styles)(UpdateSecurityQuestion);



// WEBPACK FOOTER //
// ./src/components/ResetPassword/UpdateSecurityQuestion.jsx